import React, { useCallback, useEffect, useState } from "react";
import { FaCircleExclamation } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsersById } from "../../services/apiService/userApi";
import { MdOutlineRefresh } from "react-icons/md";
import { setUser } from "../../store/slices/userSlice";
import socket from "../Socket";
import { useLocation, useNavigate } from "react-router-dom";

const CheckPermission = ({ children }) => {
  const [isChanged, setIsChanged] = useState(false);
  const { userData } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleReload = useCallback(async () => {
    try {
      const response = await fetchUsersById(userData?.id);
      dispatch(setUser(response.data));
      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  }, [userData?.id, dispatch]);

  useEffect(() => {
    const handleUserDataUpdated = (data) => {
      if (data.status) {
        setIsChanged(true);
      }
    };

    socket.on("userDataUpdated", handleUserDataUpdated);

    return () => {
      socket.off("userDataUpdated", handleUserDataUpdated);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isChanged ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isChanged]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isChanged) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    if (isChanged) {
      window.addEventListener("keydown", handleKeyDown, true);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [isChanged]);

  useEffect(() => {
    if (!userData) return;

    const shouldRedirect =
      (pathname === "/assignment" &&
        userData.articleTaskManagement === "None" &&
        userData.issueTaskManagement === "None") ||
      (pathname === "/journals" && userData.articleOverview === "None") ||
      (pathname === "/issues" && userData.issueOverview === "None") ||
      (pathname === "/settings" && userData.settings === "None");

    if (shouldRedirect) {
      navigate("/");
    }
  }, [userData, pathname, navigate]);

  return (
    <div className="relative">
      {isChanged && (
        <>
          <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm select-none" />
          <div className="fixed top-0 left-0 z-50 w-full bg-[#EEF2FA] text-[#1C40CA] border-b justify-center flex h-[64px] items-center gap-2 text-sm font-medium shadow-sm px-4">
            <div className="flex flex-row">
              <FaCircleExclamation className="w-5 h-5 text-[#1C40CA]" />
              <div className="text-[16px] flex-1 ml-4">
                <span className="font-medium">
                  User permissions have been updated. Please reload the page to
                  apply the changes.
                </span>
              </div>
            </div>

            <button
              className="w-[140px] flex rounded-md justify-center items-center h-[32px] bg-[#1C40CA] text-white text-[13px]"
              onClick={handleReload}
            >
              <MdOutlineRefresh />
              Reload Page
            </button>
          </div>
        </>
      )}

      <div className={`relative z-10 ${isChanged ? "pt-[64px]" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default CheckPermission;
